// extracted by mini-css-extract-plugin
export default {"input":"_2jeWFx3MJULCHyvD5c0KOr","icon":"_2-ACP_JhHX2zzqgZUC7b1h"};